var sessionStorageHandler = {
    set: function (key, value) {
        sessionStorage.setItem(key, value);
    },
    get: function (key) {
        return sessionStorage.getItem(key);
    },
};
export default sessionStorageHandler;
//# sourceMappingURL=sessionStorageHandler.js.map